import { createContext, useContext, useEffect, useState, type ReactNode } from "react";

interface Location {
  key: string;
  name: string;
  lat: number;
  lon: number;
  country: string;
}

interface LocationContextValue {
  locations: Location[];
  current: Location;
  setCurrent: (loc: Location) => void;
}

const DEFAULT: Location = { key: "orlando", name: "Orlando", lat: 28.5383, lon: -81.3792, country: "US" };

const LocationContext = createContext<LocationContextValue>({
  locations: [],
  current: DEFAULT,
  setCurrent: () => {},
});

export function LocationProvider({ children }: { children: ReactNode }) {
  const [locations, setLocations] = useState<Location[]>([]);
  const [current, setCurrent] = useState<Location>(DEFAULT);

  useEffect(() => {
    fetch("/api/locations")
      .then((r) => r.json())
      .then((d) => {
        if (d.locations?.length) {
          setLocations(d.locations);
          const saved = localStorage.getItem("vertali_location");
          if (saved) {
            const parsed = JSON.parse(saved);
            const match = d.locations.find((l: Location) => l.key === parsed.key);
            if (match) setCurrent(match);
          }
        }
      });
  }, []);

  const handleSet = (loc: Location) => {
    setCurrent(loc);
    localStorage.setItem("vertali_location", JSON.stringify(loc));
  };

  return (
    <LocationContext.Provider value={{ locations, current, setCurrent: handleSet }}>
      {children}
    </LocationContext.Provider>
  );
}

export function useLocation() {
  return useContext(LocationContext);
}
